import Entity from 'utilities/Entity';

class News extends Entity {}

export default new News();
